import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledContainer = styled(
  "div",
  shouldNotForwardProps(["background", "valueType", "showLowIndicator"])
)(({ theme, background, valueType, showIndicator }) => ({
  height: "24px",
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  padding: "0 3px",
  width: "max-content",
  ...showIndicator && {
    paddingRight: "0"
  },
  ...valueType === "normal" && {
    color: theme.palette.tiffanyBlue[900],
    ...background === "light" && {
      backgroundColor: theme.palette.tiffanyBlue[300]
    },
    ...background === "medium" && {
      backgroundColor: theme.palette.tiffanyBlue[400]
    },
    ...background === "dark" && {
      backgroundColor: theme.palette.tiffanyBlue[900],
      color: theme.palette.white.main
    }
  },
  ...valueType === "critical" && {
    color: theme.palette.radicalRed[900],
    ...background === "light" && {
      backgroundColor: theme.palette.primary[300]
    },
    ...background === "medium" && {
      backgroundColor: theme.palette.primary[400]
    },
    ...background === "dark" && {
      backgroundColor: theme.palette.radicalRed[900],
      color: theme.palette.white.main
    }
  }
})), StyledIcon = styled("div")(() => ({
  height: "24px",
  width: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box"
}));
export {
  StyledContainer,
  StyledIcon
};
//# sourceMappingURL=styles.js.map
